import { merge } from 'lodash'
import React, { useCallback } from 'react'
import { Styles as FloaterStyles } from 'react-floater'
import ReactJoyride, { TooltipRenderProps, Props as ReactJoyrideProps } from 'react-joyride'

import { Tooltip } from './Tooltip/Tooltip'
import { DEFAULT_ARROW } from './constants'
import { JoyRideButtonProps } from './types'

type Ref = React.ForwardedRef<ReactJoyride>

interface IProps extends ReactJoyrideProps {
  skipButtonLabel?: string
  nextButtonLabel?: string
  finalButtonLabel?: string
  arrow?: FloaterStyles['arrow']
  isStepsCountEnabled?: boolean
  customToolTip?: React.ElementType<TooltipRenderProps>
  showSkipOnLast?: boolean
  nextButtonProps?: JoyRideButtonProps
  skipButtonProps?: JoyRideButtonProps
}

export const JoyRide = React.forwardRef(
  (
    {
      skipButtonLabel,
      nextButtonLabel,
      finalButtonLabel,
      isStepsCountEnabled = true,
      arrow = DEFAULT_ARROW,
      customToolTip,
      showSkipOnLast = false,
      nextButtonProps,
      skipButtonProps,
      continuous = true,
      disableScrolling = true,
      disableCloseOnEsc = true,
      disableOverlayClose = true,
      disableScrollParentFix = true,
      ...props
    }: IProps,
    ref: Ref,
  ) => {
    const defaultTooltipComponent = useCallback(
      (props: TooltipRenderProps) => {
        return (
          <Tooltip
            {...props}
            skipButtonLabel={skipButtonLabel || ''}
            nextButtonLabel={nextButtonLabel || ''}
            finalButtonLabel={finalButtonLabel || ''}
            isStepsCountEnabled={isStepsCountEnabled}
            showSkipOnLast={showSkipOnLast}
            nextButtonProps={nextButtonProps}
            skipButtonProps={skipButtonProps}
          />
        )
      },
      [
        finalButtonLabel,
        isStepsCountEnabled,
        nextButtonLabel,
        skipButtonLabel,
        nextButtonProps,
        skipButtonProps,
        showSkipOnLast,
      ],
    )

    const tooltip = customToolTip || defaultTooltipComponent
    return (
      <ReactJoyride
        ref={ref}
        continuous={continuous}
        disableScrolling={disableScrolling}
        disableCloseOnEsc={disableCloseOnEsc}
        disableOverlayClose={disableOverlayClose}
        disableScrollParentFix={disableScrollParentFix}
        floaterProps={merge({ styles: { arrow } }, props.floaterProps)}
        tooltipComponent={tooltip}
        {...props}
      />
    )
  },
)
